import UsersDB from 'src/firebase/db/Users';

export const getUsers = (uids: string[]) => {
  return UsersDB.getUsers(uids);
};
